namespace Nobox.EmailQueue {
    export interface EmailQueueListRequest extends Serenity.ListRequest {
        IsAll?: number;
    }
}
